var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.open)?_c('aside',{staticClass:"banner"},[_c('div',[_vm._t("default")],2),_c('button',{staticClass:"banner-button",on:{"click":function($event){_vm.open = false}}},[_vm._v("Close")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }